<template>
    <div>
        <v-card class="pa-5 elevation-0" style="border-radius: 5px;">
            <v-text-field box label="Nome" v-model="user.nome" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
            <v-text-field box label="Email" v-model="user.email" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
            <v-text-field box label="Telefone" v-model="user.telefone" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
            <v-text-field box label="Senha" v-model="user.senha"  color="blue-grey" @keyup.enter="criarConta" :append-icon="showPass ? 'visibility_off' : 'visibility'" :type="showPass ? 'text':'password'" @click:append="showPass=!showPass"></v-text-field>
            <v-text-field box label="Senha" v-model="user.senhaNovamente"  color="blue-grey" @keyup.enter="criarConta" :append-icon="showPass ? 'visibility_off' : 'visibility'" :type="showPass ? 'text':'password'" @click:append="showPass=!showPass"></v-text-field>
            <v-text-field box label="Insira seu CPF ou CNPJ" v-model="user.cpf_cpnj" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
            <v-text-field box label="CEP" v-model="user.cep" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
            <v-text-field box label="Logradouro" v-model="user.logradouro" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
            <v-text-field box label="Número" v-model="user.numero" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
            <v-text-field box label="Bairro" v-model="user.bairro" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
            <v-text-field box label="Cidade" v-model="user.cidade" color="blue-grey" @keyup.enter="criarConta"></v-text-field>
            <v-text-field box label="Estado" v-model="user.estado" color="blue-grey" @keyup.enter="criarConta"></v-text-field>

            <v-btn
                :loading="loader"
                :disabled="loader"
                class="white--text mb-3"
                style="background-color: #59BDB3"
                block
                large
                round
                @click="criarConta"
            >
            <v-icon left dark v-html="loader ? 'lock' : 'lock_open'"></v-icon>
                Criar conta
            </v-btn>
            <v-layout justify-space-between row>
                <v-btn round class="elevation-0 ma-0" @click='$router.push("/login")'>
                    <v-icon left>
                        people
                    </v-icon>
                    <small>
                        Login
                    </small>
                </v-btn>
            </v-layout>
        </v-card>
        <v-dialog v-model="dialogValidaTelefone" max-width="500">
            <v-card class="pa-3">
                <h1 class="text-xs-center headline pa-3">Foi enviado um código de confirmação para o número inserido</h1>
                <v-text-field type="number" color="blue-grey" class="pl-3 pr-3" label="Insira o código aqui" box v-model="imutable.cod"></v-text-field>
                <v-btn
                    class="white--text mb-3"
                    style="background-color: #59BDB3"
                    block
                    large
                    round
                    @click="validaCodigo()"
                >
                <v-icon left dark >send</v-icon>
                    Enviar
                </v-btn>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'
    import getCep from './../helpers/GetCep'
    import cpfCnpj from './../helpers/CpfCnpj'
    import validaNumber from './../helpers/validaNumber'
import { awaitExpression } from 'babel-types';
	export default {
		data(){
			return{
                showPass: false,
                loader: false,
                loaderTelefone: false,
                user: {
                    nome: '',
                    cep: '',
                    telefone: '',
                    logradouro: '',
                    bairro: '',
                    cidade: '',
                    estado: '',
                    email: '',
                    senha:'',
                    numero: '',
                    senhaNovamente: '',
                    cpf_cpnj: '',
                    cod: ''
                },
                /*user: {
                    nome: 'David',
                    cep: '',
                    telefone: '16996282955',
                    logradouro: '',
                    bairro: '',
                    cidade: '',
                    estado: '',
                    email: 'deeh.programmer@outlook.com',
                    senha:'123456',
                    numero: '1101',
                    senhaNovamente: '123456',
                    cpf_cpnj: '43232819869',
                    cod: ''
                },*/
                dialogValidaTelefone: false,
                imutable: {}
			}
		},
		methods:{
            ...mapActions(["cadastraUsuario", "sendValidaTelefone"]),
            async showValidaTelefone () {
                if (this.user.cep && this.user.logradouro && this.user.bairro && this.user.cidade && this.user.estado && this.user.email && this.user.senha && this.user.numero && this.user.senhaNovamente && this.user.cpf_cpnj) {
                    if (this.user.senha == this.user.senhaNovamente) {
                        if (cpfCnpj(this.user.cpf_cpnj) != 0) {
                            if (this.getValidaNumber([this.user.telefone])) {
                                this.loader = true
                                let r = await this.sendValidaTelefone(this.user)
                                if (r.status) {
                                    this.imutable = Object.assign({}, this.user)
                                    this.dialogValidaTelefone = true
                                } else {
                                    this.$eventHub.$emit('snackBar', {color: 'error', message: 'Erro ao realizar cadastro'})
                                }
                            } else {
                                this.$eventHub.$emit('snackBar', {color: 'error', message: 'Número de celular inválido'})
                            }
                        } else {
                            this.$eventHub.$emit('snackBar', {color: 'error', message: 'CPF ou CNPJ inválidos'})
                        }
                    }else {
                        this.$eventHub.$emit('snackBar', {color: 'error', message: 'Senhas não conferem'})
                    }
                }else {
                    this.$eventHub.$emit('snackBar', {color: 'error', message: 'Preencha todos os campos'})
                }
            },
			async criarConta()
			{
                this.loader = true
                if (this.user.cep && this.user.logradouro && this.user.bairro && this.user.cidade && this.user.estado && this.user.email && this.user.senha && this.user.numero && this.user.senhaNovamente && this.user.cpf_cpnj) {
                    if (this.user.senha == this.user.senhaNovamente) {
                        if (cpfCnpj(this.user.cpf_cpnj) != 0) {
                            let res = await this.cadastraUsuario(this.user)
                            if(res.status) {
                                this.resetAll()
                                this.$eventHub.$emit('snackBar', {color: 'success', message: res.mensagem})
                                this.loader = false
                                this.$emit('closeModal')
                            }else{
                                this.loader = false
                                this.$eventHub.$emit('snackBar', {color: 'error', message: res.mensagem})
                            }
                        } else {
                            this.loader = false
                            this.$eventHub.$emit('snackBar', {color: 'error', message: 'CPF ou CNPJ inválidos'})
                        }
                    }else {
                        this.loader = false
                        this.$eventHub.$emit('snackBar', {color: 'error', message: 'Senhas não conferem'})
                    }
                }else {
                    this.loader = false
                    this.$eventHub.$emit('snackBar', {color: 'error', message: 'Preencha todos os campos'})
                }
            },

            reset () {
                this.user.bairro = ''
                this.user.logradouro = ''
                this.user.estado = ''
                this.user.cidade = ''
            },

            resetAll () {
                this.user = {
                    nome: '',
                    cep: '',
                    telefone: '',
                    logradouro: '',
                    bairro: '',
                    cidade: '',
                    estado: '',
                    email: '',
                    senha:'',
                    numero: '',
                    senhaNovamente: '',
                    cpf_cpnj: ''
                }
            },

            async buscarCep () {
                try{
                    let dadosCep = await getCep(this.user.cep)
                    if(dadosCep.cep) {
                    this.user.bairro = dadosCep.bairro
                    this.user.logradouro = dadosCep.logradouro
                    this.user.estado = dadosCep.uf
                    this.user.cidade = dadosCep.localidade
                }else{
                    this.reset()
                }
                }catch (e) {
                    this.reset()
                }


            },
            getValidaNumber (number) {
				return validaNumber(number)
			}
        },
        watch: {
            'user.cep'() {
                //console.log('VueMan')
                if (this.user.cep.length >=8 ) {
                    this.buscarCep()
                }else{
                    this.reset()
                }
            },
            cpf_cpnj() {

            }
        }
	}
</script>

<style lang="stylus" scoped>
    .logo
        width 100%
        margin 0 auto

	.bodyLogin
		background url('../assets/fundo2.jpg') no-repeat


	.headerLogin
		padding 30px
		color white
		font-size 2em
		font-weight normal
		text-transform uppercase
        text-align center

	.v-card
		box-shadow 0px 0px 9px #000

</style>



// WEBPACK FOOTER //
// src/components/CriarConta_OLD.vue